/**
 * Constantes responsivas centralizadas para GameModesSection Cards
 * 
 * Usa os utilitários de responsive.js para garantir que os cards
 * escalam proporcionalmente em diferentes tamanhos de tela
 */

import { moderateScale, scaleHeight, spacing, fontSizes } from '../../../utils/responsive';

// ==========================================
// ALTURAS DOS CARDS
// ==========================================

/**
 * Altura base pequena (SpeedRunCard)
 * Original: 130px
 */
export const SMALL_HEIGHT = scaleHeight(130);

/**
 * Altura slim (DailyCard, WorldMapCard)
 * Original: 60px
 */
export const SLIM_HEIGHT = scaleHeight(60);

/**
 * Gap entre cards no grid
 * Original: 12px
 */
export const CARD_GAP = spacing.md;

/**
 * Altura grande (MemoryCard - 2x2)
 * = 2 * SMALL_HEIGHT + GAP
 */
export const LARGE_HEIGHT = SMALL_HEIGHT * 2 + CARD_GAP;

// ==========================================
// FONTES RESPONSIVAS
// ==========================================

export const CARD_FONTS = {
    // Títulos
    titleLarge: moderateScale(18),     // MemoryCard title
    titleMedium: moderateScale(16),    // SpeedRunCard title
    titleSmall: moderateScale(14),     // DailyCard/WorldMapCard title

    // Descrições
    description: moderateScale(13),    // MemoryCard description
    descriptionSmall: moderateScale(12), // SpeedRunCard description

    // Subtítulos
    subtitle: moderateScale(10),       // Cards slim

    // Badges
    badge: moderateScale(11),          // Badges e labels

    // CTA
    cta: moderateScale(12),
};

// ==========================================
// ÍCONES RESPONSIVOS
// ==========================================

export const CARD_ICONS = {
    large: moderateScale(28),          // MemoryCard icon
    medium: moderateScale(24),         // WorldMapCard icon
    small: moderateScale(22),          // SpeedRunCard icon
    slim: moderateScale(26),           // DailyCard icon (∞)

    // Ícones das bancas no MemoryCard
    bancaIcon: moderateScale(28),
};

// ==========================================
// PADDING & SPACING
// ==========================================

export const CARD_PADDING = {
    large: spacing.lg,                 // 16dp scaled
    medium: spacing.md,                // 12dp scaled
    small: spacing.sm,                 // 8dp scaled
    horizontal: moderateScale(14),
    vertical: moderateScale(10),
};

// ==========================================
// BORDER RADIUS
// ==========================================

export const CARD_RADIUS = {
    large: moderateScale(18),          // Cards grandes
    medium: moderateScale(12),         // Cards menores
    small: moderateScale(8),           // Mini cards (bancas)
    badge: moderateScale(10),          // Badges
};

// ==========================================
// SHADOW (não escalável em Android, mas incluímos para iOS)
// ==========================================

export const CARD_SHADOW = {
    small: {
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 0.25,
        shadowRadius: 8,
        elevation: 6,
    },
    medium: {
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.3,
        shadowRadius: 12,
        elevation: 8,
    },
    large: {
        shadowOffset: { width: 0, height: 6 },
        shadowOpacity: 0.4,
        shadowRadius: 16,
        elevation: 10,
    },
};

// ==========================================
// EXPORT AGRUPADO
// ==========================================

export default {
    heights: {
        small: SMALL_HEIGHT,
        slim: SLIM_HEIGHT,
        large: LARGE_HEIGHT,
        gap: CARD_GAP,
    },
    fonts: CARD_FONTS,
    icons: CARD_ICONS,
    padding: CARD_PADDING,
    radius: CARD_RADIUS,
    shadow: CARD_SHADOW,
};
